import { IComponentOptions } from 'angular';
import template from './widget-wrapper.html';
import controller from './widget-wrapper.controller';
import './widget-wrapper.scss';

/**
 * @type {IComponentOptions}
 */
const component = {
	template,
	bindings: {
		widget: '<',

		onLockWidget: '&',
	},
	transclude: true,
	controller,
};

export default component;
